var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-wrapper',[(_vm.webformId)?_c('clue-webform',{attrs:{"webform-id":_vm.webformId,"gateway-url":_vm.gatewayUrl,"default-lang":_vm.defaultLang,"recaptcha-site-key":_vm.recaptchaSiteKey}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }